<script type="text/javascript">
  // AZ Flat Fee site review
  export default {
    props: ['website'],
    data() {
      return {
        title: 'AZ Flat Fee',
        url: 'https://azflatfee.com/',
        updated: '9/18/2023',

        pages: [
          // ========== START OF PAGE ==========
          {
            title: 'HOME',
            main: 1,
            url: `https://azflatfee.com`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `AZ Flat Fee - Full Service Arizona Real Estate Agents`,
            meta_desc: `Top Rated - Full Service, Flat Fee realtor. Don't be fooled by others with a flat fee mls listing that doesn't offer full service!`,
            h1: [
              `See why a Flat Fee, Full Service Realtor is best`,
              `Ready to save thousands of dollars?`,
              `Comprehensive Full Service Real Estate Solutions at an Incredibly Affordable Flat Fee`,
              `Why AZ Flat Fee?`,
              `Why AZ Flat Fee?`,
            ],
            h2: [
              `See why a Flat Fee, Full Service Realtor is best`,
              `Local Experts`,
              `Value You Deserve`,
              `Value You Deserve`,
              `You. Save. Money`,
              `Full Service`,
              `Full Service`,
              `Let Us Help You Sell Your Home Today!`,
              `Work with Local Experts`,
              `See How Much AZ Flat Fee Will Save You`,
              `Read our 5-star reviews!`,
              `Featured Areas`,
              `PHOENIX`,
              `GILBERT`,
              `TUCSON`,
              `Save Money On Your Home Today`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'BUY',
            main: 1,
            url: `https://azflatfee.com/buy`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Let AZ Flat Fee Help You Buy Your Home - AZ FLAT FEE`,
            meta_desc: `Looking to buy new properties in Arizona? Easily get started with flat fee real estate when you download our Free Buyer's Guide.`,
            h1: [
              `Let AZ Flat Fee Help You Buy Your Home`,
            ],
            h2: [
              `Download our Free Buyer's Guide`,
              `EXPERIENCE`,
              `LOCAL`,
              `LOCAL`,
              `TRUST`,
              `Frequently Asked Questions`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'SELL',
            main: 1,
            url: `https://azflatfee.com/sell`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `AZ Flat Fee Saves You $12,295.08 on Average - AZ FLAT FEE`,
            meta_desc: `Sell your home with AZ Flat Fee and pay one low fee, save thousands of dollars, and work with a top realtor in Arizona.`,
            h1: [
              `AZ Flat Fee Saves You $12,295.08 on Average`,
            ],
            h2: [
              `Sell and Save in 3 Simple Steps`,
              `Step 1`,
              `Step 2`,
              `Step 2`,
              `Step 3`,
              `Sell Your Home the Flat Fee Way`,
              `How Much Money Can You Actually Save?`,
              `Savings with AZ Flat Fee`,
              `Flat Fee Commission Savings`,
              `26,150`,
              `What Services are Provided in AZ Flat Fee's Low $3,500 Rate?`,
              `What Past Clients Say About Us`,
              `Ready to sell your home and save thousands?`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'LOCATIONS',
            main: 1,
            children: [
              // ========== START OF PAGE ==========
              {
                title: 'Phoenix',
                main: 1,
                url: `https://azflatfee.com/phoenix-arizona-realtor`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Phoenix, Arizona Realtor Services - AZ FLAT FEE`,
                meta_desc: `Whether you are looking into buying or selling real estate in Phoenix, AZ Flat Fee has the best services to offer you.`,
                h1: [
                  `Phoenix, Arizona Realtor Services`,
                ],
                h2: [
                  `Best Places to Live in Phoenix Area`,
                  `What About the Kids?`,
                  `What to Expect from AZ Flat Fee in Phoenix`,
                  `Why AZ Flat Fee in Phoenix?`,
                  `Buy & Sell Houses, Hassle Free!`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Tucson',
                main: 1,
                url: `https://azflatfee.com/tucson-arizona-realtor`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Tucson, Arizona Realtor Services - AZ FLAT FEE`,
                meta_desc: `Whether you are looking into buying or selling real estate here, an AZ Flat Fee Tucson Arizona Realtor has the best services for you.`,
                h1: [
                  `Tucson, Arizona Realtor Services`,
                ],
                h2: [
                  `Best Places to Live in Tucson Area`,
                  `What About the Kids?`,
                  `What to Expect from AZ Flat Fee in Tucson`,
                  `Why AZ Flat Fee in Tucson?`,
                  `Buy & Sell Houses, Hassle Free!`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Mesa',
                main: 1,
                url: `https://azflatfee.com/mesa-arizona-realtor`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Mesa, Arizona Realtor Services - AZ FLAT FEE`,
                meta_desc: `Whether you are looking into buying or selling real estate in Mesa, AZ Flat Fee has the best services to offer you.`,
                h1: [
                  `Mesa, Arizona Realtor Services`,
                ],
                h2: [
                  `Best Places to Live in Mesa`,
                  `What About the Kids?`,
                  `What to Expect from AZ Flat Fee in Mesa`,
                  `Why AZ Flat Fee in Mesa?`,
                  `Buy & Sell Houses, Hassle Free!`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Chandler',
                main: 1,
                url: `https://azflatfee.com/chandler-arizona-realtor`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Chandler, Arizona Realtor Services - AZ FLAT FEE`,
                meta_desc: `Whether you are looking into buying or selling real estate. A Chandler Arizona realtor from AZ Flat Fee has the best services to offer you.`,
                h1: [
                  `Chandler, Arizona Realtor Services`,
                ],
                h2: [
                  `Best Places to Live in Chandler Area`,
                  `What About the Kids?`,
                  `What to Expect from AZ Flat Fee in Chandler`,
                  `Why AZ Flat Fee in Chandler`,
                  `Buy & Sell Houses, Hassle Free!`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Gilbert',
                main: 1,
                url: `https://azflatfee.com/gilbert-arizona-realtor`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Gilbert, Arizona Realtor Services - AZ FLAT FEE`,
                meta_desc: `Whether you are looking into buying or selling real estate in Gilbert, Arizona, AZ Flat Fee has the best services to offer you.`,
                h1: [
                  `Gilbert, Arizona Realtor Services`,
                ],
                h2: [
                  `Best Places to Live in Gilbert Area`,
                  `What About the Kids?`,
                  `What to Expect from AZ Flat Fee in Gilbert`,
                  `Why AZ Flat Fee in Gilbert?`,
                  `Buy & Sell Houses, Hassle Free!`,
                ]
              },
            ],
          },
          // ========== START OF PAGE ==========
          {
            title: 'FAQ',
            main: 1,
            url: `https://azflatfee.com/faq`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Frequently Asked Questions - AZ FLAT FEE`,
            meta_desc: `If you wish to know what flat fee is and how it works, make sure to connect with us and let our agents help you with your inquiries.`,
            h1: [
              `Frequently Asked Questions`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'BLOG',
            main: 1,
            url: `https://azflatfee.com/blog`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Blog Posts - AZ FLAT FEE`,
            meta_desc: `If you're looking for updated information and tips regarding flat fee services in Arizona and how it works, make sure to follow our blog.`,
            h1: [
              `Blog Posts`,
            ],
            h2: [
              `Mortgage Rates vs Home Prices: How to Make Sense of What You Can Afford as Rates Change`,
              `How to Determine if a Neighborhood Has a Lot of Short-Term Rentals`,
              `First-Time Home Buyers Tips`,
              `Pros and Cons of Different Types of Mortgages`,
              `Impact of Rising Mortgage Rates on the Housing Market`,
              `How to Negotiate the Best Price When Buying a Home`,
              `How to Stage Your Home for a Successful Sale`,
              `Top Mistakes to Avoid When Buying a Home`,
              `Virtual Staging`,
              `Drone Photography`,
              `Recent Posts`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Schedule Consult',
            main: 0,
            url: `https://azflatfee.com/schedule-consult`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Schedule a Free Consult - AZ FLAT FEE`,
            meta_desc: ``,
            h1: [
              `Schedule a Free Consult`,
            ],
            h2: [
              `Let us help sell your home and save you money`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Why Flat Fee',
            main: 0,
            url: `https://azflatfee.com/why-flat-fee-realtors-guide`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Why Flat Fee Realtors Make the Most Sense Guide - AZ FLAT FEE`,
            meta_desc: `If you have any concerns regarding how flat fee works, simply fill out the form to download our free flat free realtors guide book.`,
            h1: [
              `Why Flat Fee Realtors Make the Most Sense Guide`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Privacy Policy',
            main: 0,
            url: `https://azflatfee.com/privacy-policy`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Privacy Policy - AZ FLAT FEE`,
            meta_desc: `Learn about azflatfee.com's privacy policies, including how the website addresses personal information and web cookies from site searches.`,
            h1: [
              `Privacy Policy`,
            ],
            h2: [
              `Who we are`,
              `What personal data we collect and why we collect it`,
              `How long we retain your data`,
              `What rights you have over your data`,
              `Where we send your data`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Sitemap',
            main: 0,
            url: `https://azflatfee.com/sitemap`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Sitemap - AZ FLAT FEE`,
            meta_desc: ``,
            h1: [
              `Sitemap`,
            ],
            h2: [
              `Pages`,
              `Posts by category`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Buyers Guide',
            main: 0,
            url: `https://azflatfee.com/buyers-guide-request`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Buyers Guide Request - AZ FLAT FEE`,
            meta_desc: `Are you a new buyer in flat fee real estate? Make sure to fill out our Buyer's Guide Request form to download our free guide.`,
            h1: [
              `Buyers Guide Request`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Search Phoenix Area',
            main: 0,
            url: `https://azflatfee.com/properties-phxsearch`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Search Phoenix Area - AZ FLAT FEE`,
            meta_desc: ``,
            h1: [
              `Search Phoenix Area`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Search Tucson Area',
            main: 0,
            url: `https://azflatfee.com/tucsonsearch`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Search Tucson Area - AZ FLAT FEE`,
            meta_desc: ``,
            h1: [
              `Search Tucson Area`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'AZ Flat Fee Listings: Phoenix Area',
            main: 0,
            url: `https://azflatfee.com/azfflistingsphoenix`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `AZ Flat Fee Listings: Phoenix Area - AZ FLAT FEE`,
            meta_desc: ``,
            h1: [
              `AZ Flat Fee Listings: Phoenix Area`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'AZ Flat Fee Listings: Tucson Area',
            main: 0,
            url: `https://azflatfee.com/azfftucsonlistings`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `AZ Flat Fee Listings: Tucson Area - AZ FLAT FEE`,
            meta_desc: ``,
            h1: [
              `AZ Flat Fee Listings: Tucson Area`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Is It Normal For the Buyer to Pay Closing Costs?',
            main: 0,
            url: `https://azflatfee.com/is-it-normal-buyer-pay-closing-costs`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Is It Normal For the Buyer to Pay Closing Costs? - AZ FLAT FEE`,
            meta_desc: `Is it normal for buyers to pay closing costs? In this post, we'll explain everything you need to know about who pays closing costs.`,
            h1: [
              `Is It Normal For the Buyer to Pay Closing Costs?`,
            ],
            h2: [
              `It is Normal for the Buyer to Pay the Closing Costs?`,
              `Can Buyers Avoid Closing Costs?`,
              `Conclusion`,
              `Recent Posts`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Does Redfin Have Hidden Fees?',
            main: 0,
            url: `https://azflatfee.com/does-redfin-have-hidden-fees`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Does Redfin Have Hidden Fees? - AZ FLAT FEE`,
            meta_desc: `Redfin offers realtor services for 1.5%, a percentage considered lower than traditional realtor fees. Does Redfin have hidden fees?`,
            h1: [
              `Does Redfin Have Hidden Fees?`,
            ],
            h2: [
              `Does Redfin Have Hidden Fees?`,
              `Related Questions`,
              `Conclusion`,
              `Recent Posts`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: '3 Most Costly Mistakes When Selling a Home',
            main: 0,
            url: `https://azflatfee.com/3-costly-mistakes-selling-home`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `3 Most Costly Mistakes When Selling a Home - AZ FLAT FEE`,
            meta_desc: `Selling your house can be emotionally challenging and time-consuming. Read on to avoid the 3 most costly mistakes when selling a home.`,
            h1: [
              `3 Most Costly Mistakes When Selling a Home`,
            ],
            h2: [
              `3 Most Costly Mistakes When Selling a Home`,
              `Conclusion`,
              `Recent Posts`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'What Is a Flat Fee in Real Estate?',
            main: 0,
            url: `https://azflatfee.com/what-flat-fee-real-estate`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `What Is a Flat Fee in Real Estate? - AZ FLAT FEE`,
            meta_desc: `Considering a flat fee brokerage for listing and selling your property? Here are the things you need to know about hiring a flat fee realtor.`,
            h1: [
              `What Is a Flat Fee in Real Estate?`,
            ],
            h2: [
              `What Is a Flat Fee in Real Estate?`,
              `Advantages of Hiring Flat Fee Listing Realtor`,
              `Related Questions`,
              `Conclusion`,
              `Recent Posts`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'How Much Will You Save?',
            main: 0,
            url: `https://azflatfee.com/how-much-will-you-save`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `How Much Will You Save? - AZ FLAT FEE`,
            meta_desc: `If you want to know how much will you save if you sign up with AZFlatFee? Let this calculator show you the magic of the flat fee process.`,
            h1: [
              `How Much Will You Save?`,
            ],
            h2: [
              `STEP 1 - Prep`,
              `STEP 2 - List`,
              `STEP 3 - Save $`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Best Neighborhoods in Gilbert',
            main: 0,
            url: `https://azflatfee.com/best-neighborhoods-gilbert`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Best Neighborhoods in Gilbert - AZ FLAT FEE`,
            meta_desc: `Gilbert offers plenty of recreational opportunities. If you’re looking for a place to relocate, here are the best neighborhoods in Gilbert.`,
            h1: [
              `Best Neighborhoods in Gilbert`,
            ],
            h2: [
              `Best Neighborhoods in Gilbert`,
              `What To Look For Before Moving to Gilbert`,
              `Conclusion`,
              `Recent Posts`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Best Neighborhoods in Phoenix',
            main: 0,
            url: `https://azflatfee.com/best-neighborhoods-phoenix`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Best Neighborhoods in Phoenix - AZ FLAT FEE`,
            meta_desc: `Are you considering to move to Phoenix? Learn more about the best neighborhoods located within this warm and vibrant city.`,
            h1: [
              `Best Neighborhoods in Phoenix`,
            ],
            h2: [
              `Best Neighborhoods in Phoenix`,
              `What To Look For Before Moving to Phoenix`,
              `Conclusion`,
              `Recent Posts`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Best Neighborhoods in Chandler',
            main: 0,
            url: `https://azflatfee.com/best-neighborhoods-chandler`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Best Neighborhoods in Chandler - AZ FLAT FEE`,
            meta_desc: `Here are some of the best neighborhoods in Chandler you can relocate to depending on your preferences and needs.`,
            h1: [
              `Best Neighborhoods in Chandler`,
            ],
            h2: [
              `Best Neighborhoods in Chandler`,
              `What To Look For Before Moving to Chandler`,
              `Conclusion`,
              `Recent Posts`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Best Neighborhoods in Mesa',
            main: 0,
            url: `https://azflatfee.com/best-neighborhoods-mesa`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Best Neighborhoods in Mesa - AZ FLAT FEE`,
            meta_desc: `Learn more about why Mesa is an ideal place to live in. Explore the best neighborhoods in Mesa to find your dream home.`,
            h1: [
              `Best Neighborhoods in Mesa`,
            ],
            h2: [
              `Best Neighborhoods in Mesa`,
              `What To Look For Before Moving to Mesa`,
              `Conclusion`,
              `Recent Posts`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Does Flat Fee MLS Listing Work?',
            main: 0,
            url: `https://azflatfee.com/does-flat-fee-mls-listing-work`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Does Flat Fee MLS Listing Work? - AZ FLAT FEE`,
            meta_desc: `Are you considering selling your property through a flat fee MLS listing? Does Flat Fee MLS listing work? Learn more about how it works.`,
            h1: [
              `Does Flat Fee MLS Listing Work?`,
            ],
            h2: [
              `Does Flat Fee MLS Listing Work?`,
              `What Is a Flat Fee MLS Listing?`,
              `Differences Between Flat Fee MLS Listing and a Flat Fee, Full Service Real Estate Realtor`,
              `Related Questions`,
              `Conclusion`,
              `Recent Posts`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Who Pays for Title Insurance in Arizona?',
            main: 0,
            url: `https://azflatfee.com/who-pays-title-insurance-arizona`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Who Pays for Title Insurance in Arizona? - AZ FLAT FEE`,
            meta_desc: `Closing costs are the costs paid after the sale of a home. These costs may vary by state, so, who pays for title insurance in Arizona?`,
            h1: [
              `Who Pays for Title Insurance in Arizona?`,
            ],
            h2: [
              `Who Pays for Title Insurance in Arizona?`,
              `Conclusion`,
              `Recent Posts`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'How Are Realtor Fees and Closing Costs Calculated?',
            main: 0,
            url: `https://azflatfee.com/how-are-realtor-fees-and-closing-costs-calculated`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `How Are Realtor Fees and Closing Costs Calculated? - AZ FLAT FEE`,
            meta_desc: `In this article, we'll be discussing the process on how to calculate realtor fees and closing costs and include them into the sale price.`,
            h1: [
              `How Are Realtor Fees and Closing Costs Calculated?`,
            ],
            h2: [
              `How Are Realtor Fees and Closing Costs Calculated?`,
              `Are Realtor Fees Part of Closing Costs?`,
              `What Is a No-Closing-Cost Mortgage?`,
              `How To Calculate Closing Costs`,
              `Are Closing Costs Negotiable?`,
              `Related Questions`,
              `Conclusion`,
              `Recent Posts`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Reviews for AZ Flat Fee',
            main: 0,
            url: `https://azflatfee.com/reviews-for-az-flat-fee`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Reviews for AZ Flat Fee - AZ FLAT FEE`,
            meta_desc: `Check out over more than 100 reviews about AZ Flat Fee on Google and Zillow and learn what they're saying about our services.`,
            h1: [
              `Reviews for AZ Flat Fee`,
            ],
            h2: [
              `Hundreds of reviews from happy past clients that saved thousands!`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'What Fees Do You Pay When Selling a House?',
            main: 0,
            url: `https://azflatfee.com/what-fees-do-you-pay-when-selling-house`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `What Fees Do You Pay When Selling a House? - AZ FLAT FEE`,
            meta_desc: `What fees do you pay when selling a house? Learn about the costs associated with selling including realtor commissions and closing costs.`,
            h1: [
              `What Fees Do You Pay When Selling a House?`,
            ],
            h2: [
              `What Fees Do You Pay When Selling a House?`,
              `Related Questions`,
              `Conclusion`,
              `Recent Posts`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Seller Guide',
            main: 0,
            url: `https://azflatfee.com/seller-guide-form`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Seller Guide Request - AZ FLAT FEE`,
            meta_desc: `Are you a new seller in flat fee real estate? Make sure to fill out our Seller's Guide Request form to download our free guide.`,
            h1: [
              `Seller Guide Request`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'How Are Realtor Commissions Calculated?',
            main: 0,
            url: `https://azflatfee.com/how-are-realtor-commissions-calculated`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `How Are Realtor Commissions Calculated? | AZ FLAT FEE`,
            meta_desc: `In this article, we discuss how are realtor commissions calculated, and the different types of real estate realtor commissions.`,
            h1: [
              `How Are Realtor Commissions Calculated?`,
            ],
            h2: [
              `How Are Realtor Commissions Calculated?`,
              `What Is the Cost of Hiring an Agent?`,
              `How To Calculate Commissions Split Between Two Realtors`,
              `Types of Real Estate Realtor Commissions`,
              `Related Questions`,
              `Conclusion`,
              `Recent Posts`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Can I List on MLS Without a Realtor?',
            main: 0,
            url: `https://azflatfee.com/can-list-on-mls-without-realtor`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Can I List on MLS Without a Realtor? - AZ FLAT FEE`,
            meta_desc: `Discover how you can list on MLS without a realtor. Learn the advantages of using flat fee MLS Listings and save more money.`,
            h1: [
              `Can I List on MLS Without a Realtor?`,
            ],
            h2: [
              `Can I List on MLS Without a Realtor?`,
              `How to List on the MLS Without a Realtor`,
              `How Does Flat Fee MLS Listings Save You Money?`,
              `Advantages of Using Flat Fee MLS Listings`,
              `Conclusion`,
              `Recent Posts`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Are Flat Fee Realtors Good?',
            main: 0,
            url: `https://azflatfee.com/are-flat-fee-realtors-good`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Are Flat Fee Realtors Good? - AZ FLAT FEE`,
            meta_desc: `Are flat fee realtors worth it? Let’s take a look at the best reasons why these agents might get you the best return on your property.`,
            h1: [
              `Are Flat Fee Realtors Good?`,
            ],
            h2: [
              `Are Flat Fee Realtors Good?`,
              `Reasons You Should Work With Flat Fee Realtors`,
              `Related Questions`,
              `Conclusion`,
              `Recent Posts`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'MEET THE TEAM',
            main: 0,
            url: `https://azflatfee.com/meet-the-team`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `MEET THE TEAM - AZ FLAT FEE`,
            meta_desc: `Knowing the people behind your investments are important, so make sure to meet the team behind AZ Flat Fee and find out how they can help.`,
            h1: [
              `MEET THE TEAM`,
            ],
            h2: [
              ``,
            ]
          },

        ],

      }
    },
    computed: {
      compPages: function() {
        var output = [];
        for(var i in this.pages) {
          var temp = JSON.parse(JSON.stringify(this.pages[i]));
          if(temp['children']) { delete temp['children']; }
          output.push(temp);
          if(this.pages[i]['children']) {
            for(var j in this.pages[i]['children']) {
              var temp = JSON.parse(JSON.stringify(this.pages[i]['children'][j]));
              if(temp['children']) { delete temp['children']; }
              output.push(temp);
            }
          }
        }
        return output;
      },
    },
    created() {

    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <w-site-navbar
      :website="website"
      :static="0"
    ></w-site-navbar>
    <main>

      <section class="bg-home pb-5">
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" style="background-image: url(https://s3.revinre.com/website/Development/background_09.jpg);"></div>
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 bg-black _o-5"></div>
        <div class="container-fluid pt-15 pb-10 m_py-35">
          <div class="row justify-content-center">
            <div class="col-lg-6">
              <div class="home-content text-center mb-4">
                <h1 class="home-title mb-3 text-white" data-aos="fade-zoom-in">Sell your home and save thousands</h1>
                <p class="text-white home-desc"  data-aos="fade-zoom-in">0% Listing fee | Average savings of $14,250 | 4.7 Star rating on Google</p>
                <div class="row mt-5">
                  <div class="col-sm px-sm-1"><a href="/selling" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-revinre aos-init">I'm selling</a></div>
                    <div class="col-sm px-sm-1"><a href="/buying" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">I'm buying</a></div>
                    <div class="col-sm px-sm-1"><a href="/valuation" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">Home valuation</a></div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section">
        <div class="container-fluid py-5">

          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:pantone-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3 text-" data-aos="fade-zoom-in">{{title}} navigation</h2>
            <p class="text-" data-aos="fade-zoom-in">Overview of {{title}}'s navigation menu, sub menu's and additional pages.</p>
          </div>

          <div class="border font-weight-bold rounded bg-lighten-success small p-5">
            <h4 class="_underline">Site info</h4>
            <div class="mb-5">
              <div class=""><strong>Company :</strong> {{title}}</div>
              <div class=""><strong>URL :</strong> {{url}}</div>
              <div class=""><strong>Last updated :</strong> {{updated}}</div>

            </div>
            <h4 class="_underline">Main navigation</h4>
            <ul class="pl-3 m-0">
              <li v-for="(item, item_i) in pages" :key="item_i" v-if="item['main']">
                <div class="font-weight-bolder">{{item['title']}}</div>
                <ul class="pl-5 m-0">
                  <li v-for="(sub1, sub1_i) in item['children']" :key="sub1_i">
                    {{sub1['title']}}
                    <ul class="pl-5 m-0">
                      <li v-for="(sub2, sub2_i) in sub1['children']" :key="sub2_i">
                        {{sub2['title']}}
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

            </ul>
            <h4 class="mt-5 _underline">Additional pages</h4>
            <ul class="pl-3 m-0">
              <li v-for="(item, item_i) in pages" :key="item_i" v-if="!item['main']">{{item['title']}}</li>
            </ul>
          </div>



        </div>
      </section>

      <section class="section">
        <div class="container-fluid py-5">

          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:pantone-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3 text-" data-aos="fade-zoom-in">{{title}} page content</h2>
            <p class="text-" data-aos="fade-zoom-in">Overview of {{title}}'s website content and SEO basics. Scroll through the table vertically and horizontally with the mouse wheel.</p>
          </div>

          <div class="table-responsive">
            <table class="table table-small table-bordered-right table-hover mb-0 text-nowrap border border-light">
              <thead class="bg-lighten-success">
                <tr>
                  <th class="font-weight-bold">Menu item</th>
                  <th class="font-weight-bold">URL</th>
                  <th class="font-weight-bold">Positives</th>
                  <th class="font-weight-bold">Negatives</th>
                  <th class="font-weight-bold">Meta title</th>
                  <th class="font-weight-bold">Meta description</th>
                  <th class="font-weight-bold">H1's</th>
                  <th class="font-weight-bold">H2's</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_i) in compPages" :key="item_i">
                  <td class="bg-light font-weight-bold">{{item['title']}}</td>
                  <td>{{item['url']}}</td>
                  <td class="_w-n-400 _w-m-400 text-wrap">
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['positives']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td class="_w-n-400 _w-m-400 text-wrap">
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['negatives']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td>{{item['meta_title']}}</td>
                  <td class="_w-n-400 _w-m-400 text-wrap">{{item['meta_desc']}}</td>
                  <td>
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['h1']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['h2']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </section>

    </main>

    <w-site-footer
      :website="website"
    ></w-site-footer>

  </section>
</template>
